var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '../../dom';
import './Alert.less';
var Alert = /** @class */ (function (_super) {
    __extends(Alert, _super);
    function Alert(props) {
        var _this = _super.call(this, props) || this;
        _this.name = 'Alert';
        _this.el = _this.DIV({ className: "& &_".concat(props.type || 'info') }, [].concat(props.content || ''));
        return _this;
    }
    Alert.prototype.setContent = function (content) {
        this.el.appendChild(this.DIV({}, [content]), true);
    };
    Alert.prototype.toggle = function (toggle) {
        _super.prototype.toggle.call(this, toggle, 'block');
    };
    return Alert;
}(Component));
export { Alert };
